import React, { useState } from "react";
import AuthLayout from "../components/AuthLayout";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ResetPasswordForm from "../components/ResetPasswordForm";
import { PORTAL } from "../utils/constant";

function ResetPassword() {
    const [response, setResponse] = useState();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate(PORTAL);
    };

    const handleBackButtonClick = () => {
        window.location.href = "https://dev-camu.devopsdemo.live/front/login";
    };
    const ResetSuccess = useSelector((state) => state);
    return (
        <div>
            <AuthLayout imageTitle={t("WelcomtoLogin")}
                imageSubtitle={t("loginToAccessPortal")}
                buttonName={t("login")}
                accountMsg={t("alreadyAccount")}
                buttonClick={handleButtonClick}
                backButtonClick={handleBackButtonClick} >
                <ResetPasswordForm />
            </AuthLayout>
        </div>
    );
}

export default ResetPassword;